<!--
 * @Author: your name
 * @Date: 2021-01-07 17:45:02
 * @LastEditTime: 2021-01-11 10:39:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lwdgis-ui-master\src\components\Account\comChangeLocation.vue
-->


<template>
    <div class="card-fa-div">
        <el-card class="box-card" style="width: 100%; height:750px;">
            <el-row>
                <h1 style="float:left">添加定位</h1>
            </el-row> 
            <div style="font-size:20px"> 
                <el-row>
                    <el-card :body-style="{ padding: '10px' }" :span="6" v-for="o in 8" :key="o">
                        <el-row>
                            <div style="text-align:left">20201-01-06</div>
                        </el-row>
                        <el-row style="margin:10px 0px">
                            <el-col :span="10">
                                <div>XXX聚落（调查表中的详细描述+用户添加的详细描述）</div>
                            </el-col>
                            <el-col :span="4">
                                <el-row>
                                    <div>经度：116</div>
                                    <div>纬度：30</div>
                                </el-row>
                            </el-col>
                            <el-col :span="4">
                                <div>奖励积分：10分</div>
                            </el-col>
                            <el-col :span="4">
                                <div>已到账</div>
                            </el-col>
                        </el-row>
                    </el-card>
                </el-row>    
            </div>
        </el-card>
    </div>


</template>

<script>


export default {
    name:'comMainInfo',
    data(){
      return{
        

       
                    
      }
    },

  components: {
    
  },

    mounted(){
      
    },

    methods:{
       

    }

}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Account/comAddLocation.vue